
export default {
  appName: 'Magic Task'
}
